import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const RenderWpForm = () => {

var md5 = require('md5');

var resturl=sessionStorage.getItem("RESTURL");

//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [dowait, setDowait] = useState({show:false});
const [imgref, setImgref] = useState({letter:"", assignedref:""});
const [modal, setModal] = useState({open:false});
const [cbreport, setCbreport] = useState({checked:false});

let date1=new Date();
date1.setMonth(date1.getMonth() - 1);
date1.setDate(1);

const [crit, setCrit] = useState({
	 date1: date1.toISOString().slice(0, 10)
	, date2: new Date().toISOString().slice(0, 10)
	});

const [tblimgrefseq, setTblimgrefseq] = useState([]);






const location = useLocation();


useEffect(() => {
document.title =   "Immig.  Ref #";

const USERNAME = sessionStorage.getItem("USERNAME")??"";
	
if (USERNAME==""){
	navigate("/");
	return;
	}//end if
	
gettblimgrefseq();
lastimgrefnbrdate();
 },[]);


useEffect(() => {

if (imgref.assignedref!=""){
	//after ref is assigned, write clipboard and clear radio input
	document.getElementById("assignedref").focus();
	writeClipboard(null, imgref.assignedref);

	const len=document.getElementsByName("rdabc").length;
	for (var i=0; i<len; i++)
		document.getElementsByName("rdabc")[i].checked=false;

	
	}//end if

setImgref((prev)=>{
	return {...prev, letter: ""}
});


 },[imgref.assignedref]);







function handleChange(e, letter){
	//const {name, value} = e.target;
	
		setImgref((prev)=>{
			return {...prev, letter: letter, assignedref:""}
		});
		
	
	
}//end func


async function lastimgrefnbrdate(e){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		
	
	setDowait({show:true});
	
 await fetch(resturl+'rarwpform/lastimgrefnbrdate',requestOptions)
      .then(res => res.json())
      .then(res => 	afterlastimgrefnbrdate(res) )
      .catch(err => console.log(err));	
	
}//end func

function afterlastimgrefnbrdate(res){

if (res.length)	{
	const date1=res[0].STAMP;
	setCrit((prev)=>{
		return {...prev
			, date1:date1
			, date2:date1
			}
	});
	}//end if
	
}//end func

async function getimgrefseq(e){

const letter=imgref.letter.trim();
console.log("submitform1 letter: "+letter);

if (letter==""){
	window.alert("you must click a letter first");
	return;
	}//end if

const confirmed=window.confirm("Are you sure you need a ref #?");
if (confirmed==false)
	return;

const params={
	letter: letter
	, username:sessionStorage.getItem("USERNAME")
	}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});
	
 await fetch(resturl+'rarwpform/getimgrefseq',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetimgrefseq(res) )
      .catch(err => console.log(err));	
	
}//end func

function aftergetimgrefseq(res){
let assignedref="";
if (res.length)	
	if (res.length==1)	
		assignedref=res[0].IMG_REF;

setImgref((prev)=>{
	return {...prev, assignedref:assignedref}
	});
}//end func



async function rptimgrefnbrlog(e){
	//e.preventDefault();
const jasperFileName="rptimgrefnbrlog.jasper";

const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, PNAM: "NIL"
		, PVAL: "1"
		, JASPER_FILE_NAME: jasperFileName
		, EXECUTEQUERY: ""
		, CALLABLESTATEMENT: " CALL BFADM.SP_RPT_IMG_REF_NBR_LOG('"+crit.date1+"' ,'"+crit.date2+"' , ~); "
		};

	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

	e.target.style.visibility='hidden';

  await fetch(resturl+'rarwpform/rptimgrefnbrlog',requestOptions)
      .then(res => 	afterrptimgrefnbrlog(res, e, jasperFileName.replace(".jasper", ".pdf")) )
      .catch(err => console.log(err));
	  
}//end func

async function afterrptimgrefnbrlog(res, e, fileName){
	//const filename="LaborClearDecline"+wptapp.LBR_CLR_APP_ID+".pdf";
	const blob = await res.blob();
	saveAs(blob, fileName);
	if (e.target)
		e.target.style.visibility='visible';
	
}//end func

async function gettblimgrefseq(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		
	
	setDowait({show:true});
	
 await fetch(resturl+'rarwpform/tblimgrefseq',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertblimgrefseq(res) )
      .catch(err => console.log(err));	
	
}//end func

async function aftertblimgrefseq(res){
	
		
if (res.length==undefined)
	return;
	
console.log('aftertblimgrefseq, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	const IMG_LETTER=col['IMG_LETTER'];
	const LAST_NBR=col['LAST_NBR'];
	const trkey='tr_'+index;
	const radioId='radio_'+index;
	//const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{downloadDoc(e, docNo);}} ><img src='img/pdf.gif' border='0' />&nbsp;{col['APPLICANT']}</a>;
	
	const htmrow=<tr key={trkey} >
	<td align='center' ><input type="radio" name="rdabc" id={radioId} onClick={(e)=>{handleChange(e, IMG_LETTER);}} /><label htmlFor={radioId} className="hand" >select {IMG_LETTER}</label></td>
	<td align='center' >{col['MODIFY_USER']}</td>
	<td align='center' >{col['MODIFY_DATE']}</td>
	</tr>;
	htmrows.push(htmrow);
	

});
//	<td align='center' >{col['EMAIL_TREASURY']}</td>

setTblimgrefseq(htmrows);

}//end func


function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function critChange(e){
const {name, value}	= e.target;
setCrit((prev)=>{
	return {...prev, [name]:value}
	});
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func




function writeClipboard(e, text1){
if (e)
	e.preventDefault();
/* var  text1= "Example text to appear on clipboard"; */
navigator.clipboard.writeText(text1).then(function() {
  //console.log('Async: Copying to clipboard was successful!');
  showsnackbar(text1+" was copied to clipboard");
}, function(err) {
  console.error('Async: Could not copy text: ', err);
});	
	
}//end func


	
	
  return (
    <>
	
		<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Immigration Reference Numbers</p>
		
		<div align="center" >
			click a letter and the button if you need a reference number:&nbsp;
			<input size="9" id="assignedref" readOnly className="gnsbro" value={imgref.assignedref}  onFocus={(e)=>{e.target.select();}} style={{textAlign:"center"}} />
			{imgref.assignedref!="" && <>&nbsp;<a href="#" onClick={(e)=>{writeClipboard(e, imgref.assignedref);}} ><img src="img/cpypst.png" border="0" /></a></>}
			
		</div>
		<div align="center" ><button className="button" onClick={(e)=>{getimgrefseq(e);}} >get a reference number for letter {imgref.letter}</button></div>
		


		
			<table align="center" style={{width:"50%", marginTop:"9px", marginBottom:"9px"}} className="customers" >
			<thead>
				<tr valign="bottom" >
				<th>Select Letter</th>
				<th>Applicant / User </th>
				<th>Date</th>
				</tr>
			</thead>
			<tbody>
				{tblimgrefseq}
			</tbody>
			</table>
		<div align="center" style={{marginBottom:"40px"}} ><button className="button" onClick={(e)=>{getimgrefseq(e);}} >get a reference number for letter {imgref.letter}</button></div>
			

			<table align="center" style={{width:"50%", marginTop:"9px", marginBottom:"9px"}}  >
			<tbody>
			{/*
				<tr>
				<td align="center" >
				<input type="checkbox" id="cbreport" onClick={(e)=>{setCbreport({checked:e.target.checked});}} />
				<label htmlFor="cbreport" >generate report</label>
				</td>
				</tr>			
			*/}
				<tr>
				<td align="center" >
				<input type="date" name="date1" value={crit.date1} onChange={(e)=>{critChange(e);}}  />
				</td>
				</tr>
				<tr>
				<td align="center" >
				<input type="date" name="date2" value={crit.date2} onChange={(e)=>{critChange(e);}}  />
				</td>
				</tr>
				<tr>
				<td align="center" >
				<button className="button" onClick={(e)=>{rptimgrefnbrlog(e);}} >run report</button>
				</td>
				</tr>
				<tr>
				<td align="center" >
				<input readOnly value={sessionStorage.getItem("RESTURL")} className="gnsbro" />
				</td>
				</tr>				
				</tbody> 
			</table>
			

<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;